import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useLocalization } from "@/providers/useLocalization";
import { useTranslations } from "@/providers/TranslationsProvider";
import type { ApplicationDocument } from "@/lib/userApplication";
import { LICENCE_COUNTRY_NAMES, OTHER_COUNTRY, licenceCountryKey } from "@/lib/licence";
import { keyFor } from "@/lib/translationHelpers";
import type { SpecialtyEntry } from "@/services/usersService";
import { sessionLanguageLabel, termLabel } from "@/utils/profile";
import { StepTitle } from "./fields";
import type { WizardDraft } from "./types";
interface ReviewStepProps {
  draft: WizardDraft;
  catalogue: SpecialtyEntry[];
  documents: ApplicationDocument[];
  confirmed: boolean;
  onConfirmedChange: (value: boolean) => void;
  onEdit: (step: number) => void;
}
export default function ReviewStep(t0) {
  const $ = _c(121);
  const {
    draft,
    catalogue,
    documents,
    confirmed,
    onConfirmedChange,
    onEdit
  } = t0;
  const {
    t
  } = useTranslations();
  const {
    language
  } = useLocalization();
  let licenceLines;
  let separator;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== catalogue || $[1] !== draft.approaches || $[2] !== draft.birthdate || $[3] !== draft.first_name || $[4] !== draft.gender || $[5] !== draft.last_name || $[6] !== draft.licence.country || $[7] !== draft.licence.issuer || $[8] !== draft.licence.lanr || $[9] !== draft.licence.npi || $[10] !== draft.licence.number || $[11] !== draft.licence.state || $[12] !== draft.licence.type || $[13] !== draft.specialties || $[14] !== language || $[15] !== t) {
    const byUuid = new Map(catalogue.map(_temp));
    separator = language === "fa" || language === "ckb" ? "\u060C " : ", ";
    const terms = uuids => uuids.map(u => byUuid.get(u)).filter(_temp2).map(e_1 => termLabel(e_1, language)).join(separator);
    let t6;
    if ($[23] !== draft.licence.country) {
      t6 = licenceCountryKey(draft.licence.country);
      $[23] = draft.licence.country;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    const countryKey = t6;
    let t7;
    if ($[25] !== countryKey || $[26] !== draft.licence.country || $[27] !== t) {
      t7 = countryKey === OTHER_COUNTRY ? draft.licence.country : t(`join.country.${countryKey}`, LICENCE_COUNTRY_NAMES[countryKey]);
      $[25] = countryKey;
      $[26] = draft.licence.country;
      $[27] = t;
      $[28] = t7;
    } else {
      t7 = $[28];
    }
    let t8;
    if ($[29] !== draft.licence.type || $[30] !== t) {
      t8 = draft.licence.type ? t(`join.licence types.${keyFor(draft.licence.type)}.label`, draft.licence.type) : null;
      $[29] = draft.licence.type;
      $[30] = t;
      $[31] = t8;
    } else {
      t8 = $[31];
    }
    const t9 = draft.licence.npi && `NPI ${draft.licence.npi}`;
    const t10 = draft.licence.lanr && `LANR ${draft.licence.lanr}`;
    let t11;
    if ($[32] !== draft.licence.issuer || $[33] !== draft.licence.number || $[34] !== draft.licence.state || $[35] !== t10 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
      t11 = [t7, t8, draft.licence.number, draft.licence.state, t9, t10, draft.licence.issuer].filter(Boolean);
      $[32] = draft.licence.issuer;
      $[33] = draft.licence.number;
      $[34] = draft.licence.state;
      $[35] = t10;
      $[36] = t7;
      $[37] = t8;
      $[38] = t9;
      $[39] = t11;
    } else {
      t11 = $[39];
    }
    licenceLines = t11;
    let t12;
    if ($[40] !== t) {
      t12 = t("join.personal title", "About you");
      $[40] = t;
      $[41] = t12;
    } else {
      t12 = $[41];
    }
    const t13 = `${draft.first_name} ${draft.last_name}`;
    let t14;
    if ($[42] !== t13) {
      t14 = t13.trim();
      $[42] = t13;
      $[43] = t14;
    } else {
      t14 = $[43];
    }
    let t15;
    if ($[44] !== draft.gender || $[45] !== t) {
      t15 = draft.gender ? t(`join.${draft.gender}`, draft.gender) : null;
      $[44] = draft.gender;
      $[45] = t;
      $[46] = t15;
    } else {
      t15 = $[46];
    }
    const t16 = draft.birthdate || null;
    let t17;
    if ($[47] !== t14 || $[48] !== t15 || $[49] !== t16) {
      t17 = [t14, t15, t16];
      $[47] = t14;
      $[48] = t15;
      $[49] = t16;
      $[50] = t17;
    } else {
      t17 = $[50];
    }
    if ($[51] !== t12 || $[52] !== t17) {
      t5 = {
        step: 0,
        title: t12,
        lines: t17
      };
      $[51] = t12;
      $[52] = t17;
      $[53] = t5;
    } else {
      t5 = $[53];
    }
    t3 = 1;
    if ($[54] !== t) {
      t4 = t("join.specialties title", "Your specialties");
      $[54] = t;
      $[55] = t4;
    } else {
      t4 = $[55];
    }
    t1 = terms(draft.specialties);
    t2 = terms(draft.approaches) || null;
    $[0] = catalogue;
    $[1] = draft.approaches;
    $[2] = draft.birthdate;
    $[3] = draft.first_name;
    $[4] = draft.gender;
    $[5] = draft.last_name;
    $[6] = draft.licence.country;
    $[7] = draft.licence.issuer;
    $[8] = draft.licence.lanr;
    $[9] = draft.licence.npi;
    $[10] = draft.licence.number;
    $[11] = draft.licence.state;
    $[12] = draft.licence.type;
    $[13] = draft.specialties;
    $[14] = language;
    $[15] = t;
    $[16] = licenceLines;
    $[17] = separator;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    licenceLines = $[16];
    separator = $[17];
    t1 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
  }
  let t6;
  if ($[56] !== t1 || $[57] !== t2) {
    t6 = [t1, t2];
    $[56] = t1;
    $[57] = t2;
    $[58] = t6;
  } else {
    t6 = $[58];
  }
  let t7;
  if ($[59] !== t3 || $[60] !== t4 || $[61] !== t6) {
    t7 = {
      step: t3,
      title: t4,
      lines: t6
    };
    $[59] = t3;
    $[60] = t4;
    $[61] = t6;
    $[62] = t7;
  } else {
    t7 = $[62];
  }
  let t8;
  if ($[63] !== t) {
    t8 = t("join.licence title", "Professional licence");
    $[63] = t;
    $[64] = t8;
  } else {
    t8 = $[64];
  }
  const t9 = licenceLines.join(" \xB7 ");
  let t10;
  if ($[65] !== documents.length || $[66] !== t) {
    t10 = documents.length ? `${t("join.documents", "Licence documents")}: ${documents.length}` : null;
    $[65] = documents.length;
    $[66] = t;
    $[67] = t10;
  } else {
    t10 = $[67];
  }
  let t11;
  if ($[68] !== t10 || $[69] !== t9) {
    t11 = [t9, t10];
    $[68] = t10;
    $[69] = t9;
    $[70] = t11;
  } else {
    t11 = $[70];
  }
  let t12;
  if ($[71] !== t11 || $[72] !== t8) {
    t12 = {
      step: 2,
      title: t8,
      lines: t11
    };
    $[71] = t11;
    $[72] = t8;
    $[73] = t12;
  } else {
    t12 = $[73];
  }
  let t13;
  if ($[74] !== t) {
    t13 = t("join.profile title", "Your public profile");
    $[74] = t;
    $[75] = t13;
  } else {
    t13 = $[75];
  }
  let t14;
  if ($[76] !== draft.languages || $[77] !== separator) {
    t14 = draft.languages.map(_temp3).join(separator);
    $[76] = draft.languages;
    $[77] = separator;
    $[78] = t14;
  } else {
    t14 = $[78];
  }
  const t15 = draft.headline || null;
  let t16;
  if ($[79] !== draft.years_of_experience || $[80] !== t) {
    t16 = draft.years_of_experience ? t("labels.yearsExperience", "{{count}} years experience").replace("{{count}}", draft.years_of_experience) : null;
    $[79] = draft.years_of_experience;
    $[80] = t;
    $[81] = t16;
  } else {
    t16 = $[81];
  }
  let t17;
  if ($[82] !== t14 || $[83] !== t15 || $[84] !== t16) {
    t17 = [t14, t15, t16];
    $[82] = t14;
    $[83] = t15;
    $[84] = t16;
    $[85] = t17;
  } else {
    t17 = $[85];
  }
  let t18;
  if ($[86] !== t13 || $[87] !== t17) {
    t18 = {
      step: 3,
      title: t13,
      lines: t17
    };
    $[86] = t13;
    $[87] = t17;
    $[88] = t18;
  } else {
    t18 = $[88];
  }
  let t19;
  if ($[89] !== t12 || $[90] !== t18 || $[91] !== t5 || $[92] !== t7) {
    t19 = [t5, t7, t12, t18];
    $[89] = t12;
    $[90] = t18;
    $[91] = t5;
    $[92] = t7;
    $[93] = t19;
  } else {
    t19 = $[93];
  }
  const sections = t19;
  let t20;
  if ($[94] !== t) {
    t20 = t("join.review title", "Review and submit");
    $[94] = t;
    $[95] = t20;
  } else {
    t20 = $[95];
  }
  let t21;
  if ($[96] !== t) {
    t21 = t("join.review subtitle", "Check your details. After you submit, our team verifies your licence - usually within two working days.");
    $[96] = t;
    $[97] = t21;
  } else {
    t21 = $[97];
  }
  let t22;
  if ($[98] !== t20 || $[99] !== t21) {
    t22 = <StepTitle title={t20} subtitle={t21} />;
    $[98] = t20;
    $[99] = t21;
    $[100] = t22;
  } else {
    t22 = $[100];
  }
  let t23;
  if ($[101] !== onEdit || $[102] !== sections || $[103] !== t) {
    t23 = <dl className="space-y-3">{sections.map(section => <div key={section.step} className="rounded-2xl bg-black/[0.03] dark:bg-white/[0.04] px-4 py-3"><div className="flex items-center justify-between gap-3"><dt className="text-[13px] font-semibold text-[var(--foreground)]">{section.title}</dt><button type="button" onClick={() => onEdit(section.step)} className="text-[12px] font-semibold text-[#0066CC] dark:text-[#409CFF] hover:underline">{t("join.edit", "Edit")}</button></div>{section.lines.filter(Boolean).map(_temp4)}</div>)}</dl>;
    $[101] = onEdit;
    $[102] = sections;
    $[103] = t;
    $[104] = t23;
  } else {
    t23 = $[104];
  }
  let t24;
  if ($[105] !== onConfirmedChange) {
    t24 = e_2 => onConfirmedChange(e_2.target.checked);
    $[105] = onConfirmedChange;
    $[106] = t24;
  } else {
    t24 = $[106];
  }
  let t25;
  if ($[107] !== confirmed || $[108] !== t24) {
    t25 = <input type="checkbox" checked={confirmed} onChange={t24} className="mt-0.5 h-4 w-4 accent-[#0066CC]" />;
    $[107] = confirmed;
    $[108] = t24;
    $[109] = t25;
  } else {
    t25 = $[109];
  }
  let t26;
  if ($[110] !== t) {
    t26 = t("join.confirm", "I confirm these details are accurate and that I hold a valid licence to practise.");
    $[110] = t;
    $[111] = t26;
  } else {
    t26 = $[111];
  }
  let t27;
  if ($[112] !== t26) {
    t27 = <span className="text-[13px] text-[var(--foreground-secondary)]">{t26}</span>;
    $[112] = t26;
    $[113] = t27;
  } else {
    t27 = $[113];
  }
  let t28;
  if ($[114] !== t25 || $[115] !== t27) {
    t28 = <label className="mt-6 flex items-start gap-3 cursor-pointer">{t25}{t27}</label>;
    $[114] = t25;
    $[115] = t27;
    $[116] = t28;
  } else {
    t28 = $[116];
  }
  let t29;
  if ($[117] !== t22 || $[118] !== t23 || $[119] !== t28) {
    t29 = <section>{t22}{t23}{t28}</section>;
    $[117] = t22;
    $[118] = t23;
    $[119] = t28;
    $[120] = t29;
  } else {
    t29 = $[120];
  }
  return t29;
}
function _temp4(line) {
  return <dd key={line} className="mt-1 text-[14px] text-[var(--foreground-secondary)] break-words">{line}</dd>;
}
function _temp3(code) {
  return sessionLanguageLabel(code);
}
function _temp2(e_0) {
  return !!e_0;
}
function _temp(e) {
  return [e.uuid, e];
}